import React, { Component } from "react";

import AuthService from "../../../../services/login/auth.service";
import history from "../../login/history";
import Titulo from "../../../generico/TituloPagina";
import Popup from "react-popup";
import $ from "jquery";
import DatosSocio from "../../../generico/DatosSocio";
import SolicitarPinTransaccionalService from "../../../../services/autogestion/SolicitarPinTransaccionalService";
import { trackPromise } from "react-promise-tracker";
import TecladoPin from "../../../generico/TecladoPin";
import md5 from "md5";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faFloppyDisk, faArrowLeft} from "@fortawesome/free-solid-svg-icons";


export default class Paso2SolicitudPinTransaccional extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.solicitarPin = this.solicitarPin.bind(this);
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  getInitialState = () => ({
    pin: undefined,
    pinConf: undefined,
  });

  resetState = () => {
    this.setState(this.getInitialState());
  };

  componentDidMount() {
    this.continuar.disabled = true;
  }

  enableNext() {
    const { pin, pinConf } = this.state;
    if (pin === undefined || pinConf === undefined) {
      this.continuar.disabled = true;
    } else if (pin.length < 6 || pinConf.length < 6) {
      this.continuar.disabled = true;
    } else {
      this.continuar.disabled = false;
    }
  }
  precondSolicitarPin() {
    const { pin, pinConf } = this.state;

    if (pin !== pinConf) {
      Popup.queue(this.notifiPopup("Info", "Los pines no coinciden"));
      return false;
    }
    return true;
  }

  solicitarPin() {
    if (this.precondSolicitarPin())
      trackPromise(
        SolicitarPinTransaccionalService.solicitarPin(md5(this.state.pin)).then(
          (response) => {
            var data = JSON.stringify(response.data);
            var jData = JSON.parse(data);
            //console.log(jData);
            if (jData.codigoRetorno === "0") {
              mensajeExito("Datos actualizados");
            } else {
              this.continuar.disabled = true;
              Popup.queue(this.notifiPopup("Info", jData.mensajeRetorno));
            }
          }
        )
      );
  }
  pinValue1 = (value) => {
    this.setState(
      {
        pin: value,
      },
      this.enableNext
    );
  };
  pinValue2 = (value) => {
    this.setState(
      {
        pinConf: value,
      },
      this.enableNext
    );
  };
  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      Contrato
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Cargar Pin
                          </span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <DatosSocio />
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="callout callout-warning consideraciones">
                    <h5>Consideraciones</h5>
                    <p>
                      Recuerde que su pin es exclusivamente para su uso
                      personal, y que la misma sustituye a su firma,
                      siendo de su entera responsabilidad el uso de la
                      misma. No la divulgue. Eximo a la Cooperativa
                      Universitaria de Ahorro y Crédito Ltda. de toda
                      responsabilidad y/o reclamo que pudiere surgir
                      eventualmente por las operaciones realizadas.
                          </p>
                  </div>
                  {this.state.message && (
                    <div className="form-group">
                      <div className="alert alert-danger" role="alert">
                        {this.state.message}
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-6 d-flex justify-content-center">
                      <div className="row" style={{ maxWidth: 250 }}>
                        <TecladoPin
                          pinValue={this.pinValue1.bind(this)}
                          label="Pin (6 dígitos) *"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 d-flex justify-content-center">
                      <div className="row" style={{ maxWidth: 250 }}>
                        <TecladoPin
                          pinValue={this.pinValue2.bind(this)}
                          label="Confirmar Pin (6 dígitos) *"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-footer">
              <div className="row">
                <div className="col-md-8">
                  <label className="input-label-bold-obligatorio float-left">
                    (*) Campos Obligatorios
                        </label>
                </div>
                <div className="col-md-2">
                  <div className="row float-right">
                    <button
                      type="submit"
                      className="btn btn-cu-quintary"
                      style={{ marginRight: 5 }}
                      onClick={(e) => {
                        this.props.returnDataPaso2();
                        this.firstStep.click();
                      }}
                    >
                    <FontAwesomeIcon icon={faArrowLeft} />  Inicio
                          </button>
                   
                  </div>
                </div>
                <div className="col-2">
                <button
                      ref={(button) => (this.continuar = button)}
                      type="submit"
                      className="btn btn-cu-primary"
                      onClick={this.solicitarPin}
                    >
                    <FontAwesomeIcon icon={faFloppyDisk} />   Guardar
                          </button>
                    <button
                      hidden
                      ref={(a) => (this.firstStep = a)}
                      onClick={this.props.firstStep}
                    ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
